import React, { Fragment } from "react";
import './ReactComponent.scss'
import ConcernReportTable from "./Tables/ConcernReportTable";
import ActionButton from "./ActionButton";

const ConcernReports = (props) =>
{
    return (
        <Fragment>

            <div className='component-wrapper'>
                <div className='table-wrapper'>
                        <ConcernReportTable school_id={props.school_id}></ConcernReportTable>
                </div>
            </div>
        </Fragment>
    ) ;
};

export default ConcernReports;
